import type { ObjectId } from "@bbj-types/utils";
import { type Dispatch, type SetStateAction, createContext, useContext, useMemo, useState } from "react";
import { ModalEditContact } from ".";

interface IModalEditcontactContext {
  contactToEdit: ObjectId | null;
  setContactToEdit: Dispatch<SetStateAction<IModalEditcontactContext["contactToEdit"]>>;
}

const Context = createContext<IModalEditcontactContext>({
  contactToEdit: null,
  setContactToEdit: () => undefined,
});

export const useModalEditContactContext = () => useContext(Context);

export const ModalEditContactWithProvider = ({ children }) => {
  const [contactToEdit, setContactToEdit] = useState<ObjectId | null>(null);

  const value = useMemo(
    () => ({
      contactToEdit,
      setContactToEdit,
    }),
    [contactToEdit]
  );

  return (
    <Context.Provider value={value}>
      <ModalEditContact
        open={Boolean(contactToEdit)}
        contactId={contactToEdit}
        onClose={() => setContactToEdit(null)}
      />
      {children}
    </Context.Provider>
  );
};
